export default "__VITE_ASSET__C20SpES4__"